/**
 * @generated SignedSource<<bbaae0dc981721be41106fad45478c3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardFlightsTableRow_flight$data = {
  readonly createdAt: string | null;
  readonly departureDate: string;
  readonly id: string;
  readonly lastSuccessfulUpdate: {
    readonly createdAt: string;
  } | null;
  readonly shortName: string;
  readonly updatedAt: string | null;
  readonly " $fragmentType": "DashboardFlightsTableRow_flight";
};
export type DashboardFlightsTableRow_flight$key = {
  readonly " $data"?: DashboardFlightsTableRow_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsTableRow_flight">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardFlightsTableRow_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departureDate",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightPrice",
      "kind": "LinkedField",
      "name": "lastSuccessfulUpdate",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};
})();

(node as any).hash = "26f93967b90c5053ffb642bb51b71f33";

export default node;
